import { EffectCallback, DependencyList, useEffect, useLayoutEffect } from 'react'

const useIsomorphicLayoutEffectImpl = typeof window !== 'undefined' ? useLayoutEffect : useEffect
export function useIsomorphicLayoutEffect(effect: EffectCallback, deps: DependencyList) {
  useIsomorphicLayoutEffectImpl(effect, deps)
}
